import React from 'react';
import useEntitlement from '../../hooks/useEntitlement';
import { COPY } from '../../contracts/copyMap';

// "TRIAL · 5 DAYS REMAINING".
//
// This is the entire reason billingApi keeps `trialing` distinct from `active`
// instead of collapsing the two the way LANE-B-BILLING.md specified. A trial
// with no visible clock converts worse and surprises people when it ends.
//
// Renders nothing for anyone not on a trial, so it can be dropped into a
// header unconditionally.
//
// `pill` drops the status prefix and wraps the count in a bordered pill with a
// leading Aurum dot — the /membership page form, where a Censor Bar directly
// above already says MEMBER · TRIAL and repeating it would be the third time
// the word appears in four lines. The day-count logic stays in one place
// either way; only the chrome differs.
//
// The dot is Aurum, not green. DESIGN.md §2.2 forbids saturated hues and §14
// bans coloured status dots by name.
export default function TrialBadge({ className = '', pill = false }) {
  const { trialDaysLeft } = useEntitlement();

  // `== null` catches undefined too. The hook always supplies the field, but a
  // partial stub that omits it should render nothing rather than "undefined
  // DAYS REMAINING" on a real page.
  if (trialDaysLeft == null) return null;

  const unit = trialDaysLeft === 1
    ? COPY.MEMBERSHIP_TRIAL_REMAINING_ONE
    : COPY.MEMBERSHIP_TRIAL_REMAINING_MANY;

  if (pill) {
    return (
      <span
        className={[
          'inline-flex items-center gap-2 rounded-full border border-[rgba(201,164,92,0.35)]',
          'px-3.5 py-2 font-display uppercase text-[11px] tracking-[0.2em] text-bone-dim',
          className,
        ].filter(Boolean).join(' ')}
        data-testid="trial-badge"
      >
        <span aria-hidden="true" className="w-1.5 h-1.5 rounded-full bg-aurum" />
        {`${trialDaysLeft} ${unit}`}
      </span>
    );
  }

  return (
    <span
      className={`font-censor uppercase text-[11px] tracking-[0.14em] text-aurum ${className}`}
      data-testid="trial-badge"
    >
      {`${COPY.MEMBERSHIP_STATUS_TRIAL} · ${trialDaysLeft} ${unit}`}
    </span>
  );
}
